import {Component, ElementRef, Input, OnChanges, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import Question from "../../model/question.model";
import {QuestionType} from "../../enums/question-type";
import {CountableTextareaComponent} from "../countable-textarea/countable-textarea.component";
import {FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {InputComponent} from "../input/input.component";

import {config} from "../../../../config";
import QuestionChoice from "../../model/question-choice.model";

@Component({
    selector: 'app-question',
    templateUrl: './question.component.html',
    imports: [
    CountableTextareaComponent,
    ReactiveFormsModule,
    InputComponent
],
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './question.component.scss'
})

export class QuestionComponent implements OnChanges {

  @Input({ required: true })
  question!: Question;

  @Input({ required: true })
  form!: FormGroup;

  @ViewChild('input') input !: ElementRef;
  @ViewChild('textarea') textarea !: ElementRef;

  public ngOnChanges(): void {
    this.setPositionOfChoices();
    this.setFormValidators();
  }

  protected readonly QuestionType: typeof QuestionType = QuestionType;
  protected readonly String = String;
  private value: string[] = [];

  protected onRadioChange(event: Event) {
    const radio: HTMLInputElement = (event.target as HTMLInputElement);
    this.form.controls['radio'].setValue(radio.value);
  }

  protected onCheckboxChange(event: Event) {
    const checkbox: HTMLInputElement = (event.target as HTMLInputElement);
    if (!checkbox.checked) {
      this.value.splice(this.value.indexOf(checkbox.value), 1);
    } else {
      this.value.push(checkbox.value);
    }
    this.form.controls['checkbox'].setValue(this.value);
  }

  protected onTextChange(event: Event) {
    const textarea: HTMLTextAreaElement = (event.target as HTMLTextAreaElement);
    this.form.controls['textarea'].setValue(textarea.value);
  }

  private setFormValidators(): void {
    if (!this.form) {
      return;
    }
    this.value = [];
    this.form.controls['checkbox'].setValidators(null);
    this.form.controls['radio'].setValidators(null);
    this.form.controls['textarea'].setValidators(null);

    switch (this.question.type_id) {
      case QuestionType.MULTIPLE_CHOICE:
        this.form.controls['checkbox'].setValidators([
          Validators.required,
        ]);
        break;
      case QuestionType.SINGLE_CHOICE:
        this.form.controls['radio'].setValidators([
          Validators.required,
        ]);
        break;
      case QuestionType.OPEN:
        this.form.controls['textarea'].setValidators([
          Validators.minLength(0),
          Validators.maxLength(config.textMaxCharacterCount)
        ]);
        break;
    }
    this.form.controls['checkbox'].updateValueAndValidity();
    this.form.controls['radio'].updateValueAndValidity();
    this.form.controls['textarea'].updateValueAndValidity();
  }

  private setPositionOfChoices(): void {
    this.question?.questionChoices.sort((a: QuestionChoice, b: QuestionChoice) => a.position < b.position ? -1 : 1);
  }
}
